import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../../Components/navbar/navbar";
import Footer from "../../Components/footer/footer";
import { IoIosArrowDown, IoMdSearch } from "react-icons/io";
import { MdLocationOn, MdCalendarToday, MdOpenInNew } from "react-icons/md";
import "./calendar.css";
import ScrollToTop from "../../Components/scrollToTop/scrollToTop";
import axios from "axios";

function Calendar() {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [searchEvent, setSearchEvent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleScroll = (e) => {
    e.preventDefault();
    const section = document.querySelector(".ourCalendar");
    if (section) {
      window.scrollTo({
        top: section.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchEvent(value);
    filterEvents(value);
  };

  const filterEvents = (searchTerm) => {
    const filtered = events.filter((event) =>
      event.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      event.event_type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      event.state.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredEvents(filtered);
  };

  useEffect(() => {
    getCalendarEvents();
  }, []);

  const getCalendarEvents = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACK}/0a2b15b1a0d8d09e86d4b42d2012a091/calendars`
      );

      if (response.data.data) {
        // Ordenar eventos por fecha de inicio (ascendente - más antiguos primero)
        const sortedEvents = response.data.data.sort((a, b) => {
          return new Date(a.start_date) - new Date(b.start_date);
        });
        setEvents(sortedEvents);
        setFilteredEvents(sortedEvents);
      }
      setError(null);
    } catch (error) {
      console.log(error);
      setError("No se pudieron cargar los eventos");
    } finally {
      setLoading(false);
    }
  };

  const handleInputsClear = () => {
    setSearchEvent("");
    setFilteredEvents(events);
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  const getMonthName = (dateString) => {
    const monthNames = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];
    try {
      const date = new Date(dateString);
      const monthIndex = date.getMonth();
      return monthNames[monthIndex] || "MES";
    } catch (e) {
      return "MES";
    }
  };

  const getDateObj = (dateString) => {
    try {
      const date = new Date(dateString);
      const monthName = getMonthName(dateString);
      return {
        day: date.getDate(),
        month: monthName || "MES",
        year: date.getFullYear()
      };
    } catch (e) {
      return {
        day: 1,
        month: "MES",
        year: 2026
      };
    }
  };

  // Agrupar eventos por mes y año
  const groupedEvents = {};
  filteredEvents.forEach((event) => {
    const monthYear = `${getMonthName(event.start_date)} ${new Date(event.start_date).getFullYear()}`;
    if (!groupedEvents[monthYear]) {
      groupedEvents[monthYear] = [];
    }
    groupedEvents[monthYear].push(event);
  });

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>Calendario | WA México</title>
        <meta name="description" content="Calendario de eventos y competencias de World Archery México." />
      </Helmet>
      <NavBar />
      <section className="contOurAthletes">
        <div className="athletes-title">
          <h1>Calendario de Eventos</h1>
        </div>

        <div className="contentParrafoAthletes">
          <p>
            Consulta el calendario de competencias y eventos de World Archery México.
          </p>
        </div>

        <div>
          <a
            href="#"
            className="scroll-down"
            address="true"
            onClick={handleScroll}
          >
            <IoIosArrowDown className="scroll-down-arrow" />
          </a>
        </div>
      </section>

      <div className="container">
        <section className="ourCalendar" id="ourCalendar">
          <div className="our_Athletes_title">
            <h2>Eventos Próximos</h2>
          </div>
        </section>


        <div className="events-timeline">
          {loading ? (
            <div className="loading-message">
              <p>Cargando eventos...</p>
            </div>
          ) : error ? (
            <div className="error-message">
              <p>{error}</p>
            </div>
          ) : filteredEvents.length === 0 ? (
            <div className="no-events-message">
              <p>No hay eventos disponibles</p>
            </div>
          ) : (
            Object.entries(groupedEvents).map(([monthYear, monthEvents]) => (
              <div key={monthYear} className="events-month-group">
                <h3 className="month-title">{monthYear}</h3>
                <div className="events-list">
                  {monthEvents.map((event) => {
                    const startDate = getDateObj(event.start_date);
                    const endDate = getDateObj(event.end_date);
                    const isSameDay = event.start_date === event.end_date;
                    const dateRange = isSameDay
                      ? `${startDate.day}-${startDate.day}`
                      : `${startDate.day}-${endDate.day}`;

                    return (
                      <div key={event.id} className="event-card">
                        <div className="event-date-badge">
                          <div className="badge-day">{startDate?.day || 1}</div>
                          <div className="badge-month">{startDate?.month?.substring(0, 3) || "MES"}</div>
                        </div>

                        <div className="event-dot"></div>

                        <div className="event-content">
                          <h4 className="event-title">{event.name}</h4>

                          <div className="event-meta">
                            <span className="event-type-tag">{event.event_type}</span>
                          </div>

                          <div className="event-details">
                            <div className="detail-row">
                              <MdLocationOn className="detail-icon" />
                              <div className="detail-text">
                                <p className="detail-label">{event.state}, {event.country}</p>
                                <p className="detail-sublabel">{event.venue}</p>
                              </div>
                            </div>

                            <div className="detail-row">
                              <MdCalendarToday className="detail-icon" />
                              <p className="detail-text">{dateRange} {startDate?.month?.toLowerCase() || "mes"}</p>
                            </div>
                          </div>

                          {event.address && (
                            <div className="event-address">
                              <p>{event.address}</p>
                            </div>
                          )}

                          <div className="event-actions">
                            {event.g_maps_url && (
                              <a href={event.g_maps_url} target="_blank" rel="noopener noreferrer" className="maps-link">
                                <MdOpenInNew className="maps-icon" />
                                Ver en Google Maps
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Calendar;
